module.exports = __webpack_public_path__ + "img/close.81631765.svg";